import { Country } from '@utils/pageConfig/Types';

export const getSelectedMarkets = (selectedCountries: any, entitledMarkets: Country[]): { countryId: string }[] => {
  if (!selectedCountries) {
    return [];
  }

  const selectedMarkets: string[] = Array.isArray(selectedCountries) ? selectedCountries : [selectedCountries];

  return entitledMarkets
    .filter((market) => selectedMarkets.includes(market.id))
    .map((market) => ({
      countryId: market.id,
    }));
};
